
export enum TipoSolicitud {
  AFILIACION_TITULAR = 0,
  CAMBIO_ESTADO_CIVIL = 1,
  RETIRO_BENEFICIARIO = 2,
  RETIRO_TRABAJADOR = 3,
  AFILIACION_BENEFICIARIO = 4,
  SOLICITUD_DISCAPACIDAD = 5,
  ACM = 6,
  NOVEDAD_CUOTA_MONETARIA = 8,
  NOVEDAD_DISCAPACIDAD = 9
}
